import React from "react";
import { withRouter } from "react-router";
import Base from "../template/Layout/Base.js";
import { MenuHandler, NameRole } from "./MenuHandler.js";
import axios from "axios";
import { Services } from "./Services";
import Loader from "../Global/Loader";
import Authentication from "../../services/Authentication.js";
import { roleModuleFilter } from "../Global/Permission/constants";

const auth = new Authentication();

/*=============================================
=            Component For WrapperRoute       =
=============================================*/

function WrapperRoute(props) {
  const MainComponent = props.component;
  let token = auth.getAuthentication("token");
  let RoleId = auth.getAuthentication("RolId");
  let UserId = auth.getAuthentication("dataUser");
  let UserNameLast = auth.getAuthentication("UserNameLast");
  let UserName = auth.getAuthentication("UserName");
  let Rol = auth.getAuthentication("Rol");
  let EnableBoards = auth.getAuthentication("EnableBoards");
  const [tokenExpired, setTokenExpired] = React.useState(false);

  let passwordExpiredData = JSON.parse(
    auth.getAuthentication("PasswordExpired"),
  );

  //Props para service desk
  let ProjectId = 2;
  let Email = auth.getAuthentication("EmailUser");
  let Role = NameRole[RoleId];

  let moduleLog = {
    UsuarioId: UserId,
    ModuleId: props.name,
    Date: new Date(),
    SessionId: token,
  };

  navigator.sendBeacon(
    "https://roldanapiaudit.azurewebsites.net/modules/login",
    JSON.stringify(moduleLog),
  );

  window.addEventListener("beforeunload", function (event) {
    const createOffsetValue = (date) => {
      var sign = date.getTimezoneOffset() > 0 ? "-" : "+";
      var offset = Math.abs(date.getTimezoneOffset());
      var hours = Math.floor(offset / 60);
      var minutes = ((offset % 60) / 60) * 10;
      return sign + hours + "." + minutes;
    };

    let endSession = {
      SessionId: token,
      EndConnection: new Date(),
      timezone: createOffsetValue(new Date()),
      Logout: "1",
    };

    // navigator.sendBeacon("http://localhost:3019/user/logout", JSON.stringify(endSession))
    navigator.sendBeacon(
      "https://roldanapiaudit.azurewebsites.net/user/logout",
      JSON.stringify(endSession),
    );
  });
  const { history } = props;
  const GetAuthentication = React.useCallback(async () => {
    try {
      // const oauthData =
      await axios.get(`${Services.ADMIN.path}/oauth/validate?token=${token}`);
    } catch (error) {
      setTokenExpired(true);
      auth.deleteAuthentication("token");
      auth.deleteAuthentication("dataUser");
      auth.deleteAuthentication("customerSelect");
      history.push("/");
    }
  }, [token, history]);

  const validatePermission = () => {
    let rolActions = roleModuleFilter.find((rol) => {
      return rol.Rol == RoleId;
    });
    let havePermission = false;
    if (rolActions) {
      havePermission =
        rolActions.Full || rolActions.Filters.includes(props.moduleAction);

      console.log("havePermission", havePermission);
    }
    if (!havePermission && RoleId == 2) {
      if (EnableBoards == "false") {
        history.push("/dashboard");
      } else if (props.moduleAction != "TABLEROS_ADUANA") {
        history.push("/dashboard");
      }
    } else if (!havePermission) {
      history.push("/dashboard");
    }
  };

  React.useEffect(() => {
    GetAuthentication();
  }, [props.component, GetAuthentication]);

  React.useEffect(() => {
    if (props.moduleAction) {
      validatePermission();
    }
  }, []);

  return (
    <React.Fragment>
      <Base
        Menu={{
          Menu:
            RoleId == 2
              ? EnableBoards == "true"
                ? MenuHandler[2][0]
                : MenuHandler[2][1]
              : MenuHandler[RoleId],
        }}
        SideBarConfig={{
          nada: "user nothing",
          UserNameLast: UserNameLast,
          UserName: UserName,
          RoleId: RoleId,
          Rol: Rol,
          passwordExpiredData: passwordExpiredData,
          tokenExpired: tokenExpired,
        }}
      >
        <MainComponent
          // name={props.name}
          _user={UserId}
          _rolId={RoleId}
          ProjectId={ProjectId}
          UserNameLast={UserNameLast}
          Rol={Rol}
          UserName={UserName}
          Email={Email}
          _Role={Role}
          CustomLoader={Loader}
          history={history}
          customHeader={
            <div className="content-heading">
              <span className="icon-question-circle-o icon-header" />
              <legend className="legendTitle">
                <em className="far fa-question-circle mr-2" />
                Service Desk
              </legend>
            </div>
          }
        />
      </Base>
    </React.Fragment>
  );
}

export default withRouter(WrapperRoute);
